import { useCallback, useRef, useState, useEffect } from 'react'

//current prototype version
//is relying on setSuspend redefining status, which then causes <Boundary>...<Tester /> to rerender 

export default function useFetch(tag, delay = 0, customReq = null) {
    //INTRODUCING EXTRA DELAY IN ORDER TO BRIEFLY DISPALY SUSPENSE FALLBACK
    const [suspend, setSuspend] = useState(false); //needed separate reference for suspend because there's no way to test the pending/fulfilled status of a promise
    const promise = useRef(null);
    const error = useRef(null);
    const errorFlag = useRef(null);
    const [data, setData] = useState(null) //maybe come back l8r, turn this into a useReducer, would allow me to update results outside of the fetch hook

    useEffect(() => {
        if(data) console.log(data)
    }, [data])

    const status = useCallback((phase) => {
        //idea is for this function to be called by <Boundary>, so any thrown promises/errors can be caught at desired location in DOM
        // console.log(phase, suspend, promise, error, data)
        if (phase === 1 && suspend) {
            if (!(promise.current instanceof Promise)) {
                error.current = new Error('Suspend triggered without a promise')
                setSuspend(false)
            }
            else {
                throw promise.current
            }
        }
        if (phase === 2 && error.current) {
            throw error.current
        }
        if (phase === 3 && error.current) {
            //resets error
            error.current = null; 
        }
    }, [suspend])

    const makeRequest = useCallback((url, options) => {
        error.current = false;
        errorFlag.current = false;
        setSuspend(true); 
        setData(null); //want to reset between successive requests
        promise.current = new Promise((resolve, reject) => {
            //may want to deliberately pause in order to demo suspense component briefly, though wouldn't use in normal production
            setTimeout(() => { resolve() }, delay)})
            .then(() => {
                if(typeof customReq === 'function') return customReq(errorFlag, url, options)
                else return (
                    fetch(url, options)
                        .then(r => {
                            if (!r.ok) errorFlag.current = { status: r.status }
                            let type = r.headers.get("Content-Type").split(';')[0] //header also had charset info I don't care about
                            if (type === 'application/json') return r.json()
                            else throw new Error(`Status: ${r.status} - Got unexpected Content-Type: ${type}`)
                        })
                )
            })
            //at this stage customReq will need to either 
            // (1) if !r.ok, set erroFlag.current = {status: r.status}, then regardless of r.ok, return r.json()
            // (2) throw an error
            .then(r => {
                if (errorFlag.current) {
                    error.current = new Error(`${tag}++Status: ${errorFlag.current.status} - ${r.msg}`) //for when I get a specific error msg back from server as json r.msg
                }
                else return r; 
            })
            .then(setData)
            .catch(e => {
                e.message = `${tag}++${e.message}` //want to prepend a tag that will tell my Boundary component what error screen to render
                error.current = e;
            })
            .then(() => setSuspend(false))
    }, [customReq]) //listen for changes here, EG such as when viewArticleRequest might change w/ constructing (see Blog context)

    return [makeRequest, status, data]
}


//DUMMY CODE FOR TESTING SUSPENSE/BOUNDARY W/O ACTUAL FETCH REQUESTS
// promise.current = 
// new Promise((resolve, reject) => {
//     setTimeout(() => { resolve('Finished!') }, 2000)
//     // setTimeout(() => { reject(new Error("Damnit Bobby!")) }, 3000)
// })
//     .then(r => setData(r))
//     .catch(e => {
//         e.message = `${tag}++${e.message}` //want to prepend a tag that will tell my Boundary component what error screen to render
//         error.current = e;
//     })
//     .then(() => setSuspend(false))